enum RoutePaths {
  Dashboard = "/",
  RepurchaseLogs = `/recompra/logs`,
  RepurchaseChannels = `/recompra/canales`,
  RepurchaseFrecuencies = `/recompra/frecuencias`,
  RepurchaseChannelsCreate = `/recompra/canales/crear`,
  RepurchaseChannelsEdit = `/recompra/canales/edit/:id`,
  BusinessChannels = `/negocio/canales`,
  BusinessChannelsCreate = `/negocio/canales/crear`,
  BusinessChannelsEdit = `/negocio/canales/edit/:id`,
  ApplicationIntermediaries = `/application/intermediaries`,
  ApplicationIntermediariesCreate = `/application/intermediaries/create`,
  ApplicationIntermediariesEdit = `/application/intermediaries/edit/:id`,
  Login = `/login`,
}

export { RoutePaths };
